import { useField } from 'formik';
import Select from 'react-select';
import { useTheme } from 'styled-components';
import { ErrorMessage } from 'styles/Styles.styled';
import { Theme } from 'styles/theme';
import { Option } from 'types/types';

import { getCustomWizardSelectStyles } from '../epd-compiler-inputs/select-styles';

const SelectFormField = ({ label, options, handlePostChangeAction, ...props }: any) => {
  const theme = useTheme() as Theme;
  const [field, meta, helpers] = useField(props);
  const customSelectStyles = getCustomWizardSelectStyles(theme);

  // Extract the necessary values from formik's field props
  const { name, value, onBlur, onChange } = field;

  // Create an object that matches the expected format of react-select
  const selectValue = props.isMulti
    ? options?.filter((option: Option) => value?.includes(option.value))
    : options?.find((option: Option) => option?.value === value) ?? '';

  // Define a custom onChange function that updates formik's field value
  const handleChange = (selectedOption: Option) => {
    const selectedValue = selectedOption ? selectedOption.value : '';
    if (field.value === selectedValue) {
      return;
    }
    onChangeSelectValue(selectedValue);
  };

  const handleMultiChange = (selectedOptions: Option[]) => {
    const selectedValue = selectedOptions ? selectedOptions.map((i: Option) => i.value) : [];
    onChangeSelectValue(selectedValue);
  };

  const onChangeSelectValue = (value: any) => {
    const event = { target: { name, value } };
    onChange(event);
    if (handlePostChangeAction) {
      handlePostChangeAction(event);
    }
  };

  return (
    <div>
      <label htmlFor={name}>{label}</label>
      <Select
        id={name}
        options={options}
        value={selectValue}
        onBlur={(event) => {
          helpers.setTouched(true);
          onBlur(event);
        }}
        onChange={props.isMulti ? handleMultiChange : handleChange}
        styles={customSelectStyles}
        {...props}
      />
      {meta.touched && meta.error && <ErrorMessage style={{ margin: '0.5rem 0 0.5rem' }}>{meta.error}</ErrorMessage>}
    </div>
  );
};

export default SelectFormField;
